@use "../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        padding: 0 0.125rem;
        cursor: pointer;
        color: colors.$mmc-soft-slate;
        border-radius: 0.25rem;
        display: flex;
        height: 2rem;
        min-width: 2rem;
        align-items: center;
        justify-content: center;
        width: max-content;

        &:hover {
          background-color: colors.$mmc-soft-gray;
        }

        svg {
          height: 1rem;
        }
      }

      .active {
        background-color: colors.$mmc-primary-010;
        color: colors.$mmc-primary-100;
      }
    }
  }
}
